<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card>
        <div class="container-to-table mb-auto">
            <div class="content">
                <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="clients"
                        dense
                        item-key="user_id"
                        :show-select="selectedTable"
                        :options.sync="options"
                        :page.sync="page"
                        :server-items-length="countClients"
                        :loading="loading"
                        class="elevation-1"
                        :footer-props="{
                          showFirstLastPage: true,
                          'items-per-page-options': [5, 10, 15, 30],
                          itemsPerPageText: 'Клиентов на странице ',
                          itemsPerPageAll: 'qwerty',
                          showCurrentPage: false
                        }"
                        :search="search"
                        :height="mobile ? windowHeight : windowHeight - 250"
                >
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Пользователи</v-toolbar-title>
                            <v-divider
                                    class="mx-4"
                                    inset
                                    vertical
                            ></v-divider>
                            <v-spacer></v-spacer>
                            <v-row>
                                <v-col cols="3">
                                    <v-select
                                            label="Поиск по: "
                                            :items="searchByItems"
                                            v-model="searchBy"
                                            hide-details
                                    ></v-select>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                            v-model="search"
                                            :label="searchLabel"
                                            single-line
                                            hide-details
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn @click="searchClients">
                                        <span class="text-none">
                                            <v-icon>search</v-icon>Поиск
                                        </span>
                                    </v-btn>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn @click="reloadClients">
                                        <span class="text-none">
                                            <v-icon>search</v-icon>Поиск
                                        </span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.created_at="{ item }">
                        {{getDate(item.created_at)}}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon
                                small
                                class="mr-2"
                                @click="editClient(item.user_id)"
                        >
                            edit
                        </v-icon>
                    </template>
                </v-data-table>
            </div>
        </div>
        <client-bottom-bar
                :selected="selected"
                :mailingGroupId="mailingGroupId"
                @clearSelected="selected = []"
                @addClientsNotification="addClientsNotification"
        >
        </client-bottom-bar>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
        <client-form
                :dialog="clientFormShow"
                :client-id="clientId"
                @close="clientFormShow = false"
        ></client-form>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import ClientBottomBar from './ClientBottomBar'
import ClientForm from './forms/ClientForm'
import timeHelpers from '../../../scripts/helpers/timeHelpers'
export default {
    name: 'ClientTable',
    props: ['mailingGroupId'],
    components: {
        ClientBottomBar,
        ClientForm
    },
    data() {
        return {
            search: '',
            searchBy: 'last_name',
            options: { itemsPerPage: 15 },
            page: 1,
            totalClients: 0,
            loading: true,
            headers: [
                {
                    text: 'id',
                    align: 'left',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: 'Ник',
                    align: 'left',
                    sortable: false,
                    value: 'username'
                },
                {
                    text: 'Имя',
                    align: 'left',
                    sortable: false,
                    value: 'first_name'
                },
                {
                    text: 'Фамилия',
                    align: 'left',
                    sortable: false,
                    value: 'last_name'
                },
                {
                    text: 'Дата регистрации',
                    align: 'left',
                    sortable: false,
                    value: 'created_at'
                },
                {
                    text: 'Действия',
                    value: 'action',
                    sortable: false
                }
            ],
            searchByItems: [
                { value: 'username', text: 'нику' },
                { value: 'first_name', text: 'имени' },
                { value: 'last_name', text: 'фамилии' },
                { value: 'id', text: 'id пользователя' }
            ],
            selected: [],
            lastPage: 1,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            clientFormShow: false,
            clientId: null,
            windowHeight: 0,
            mobile: false,
            firstLoadUnfoundedClient: false
        }
    },
    computed: {
        ...mapGetters({
            clients: 'clients/clients',
            getFirstClient: 'clients/getFirstClient',
            getLastClient: 'clients/getLastClient',
            countClients: 'clients/getCountClients'
        }),
        searchLabel() {
            let index = this.searchByItems.findIndex(item => item.value === this.searchBy)
            return 'Поиск по ' + this.searchByItems[index].text
        },
        selectedTable() {
            return this.mailingGroupId !== 1
        },
        ...timeHelpers
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true
        },
        mailingGroupId() {
            this.selected = []
            this.page = 1
            this.search = ''
            this.$store.dispatch('clients/getClientsCount',
                { botId: this.$route.params['pathMatch'], group_id: this.mailingGroupId, search_text: this.search, search_by: this.searchBy })
            this.getDataFromApi()
        },
        clients: {
            handler() {
                if (this.$route.params['clientId'] && this.clients.length > 0) {
                    let index = this.clients.find(client => client.user_id === +this.$route.params['clientId'])
                    if (!index) { // если ордер не был в списке ордеров, то нужно загрузить
                        if (!this.firstLoadUnfoundedClient) {
                            this.firstLoadUnfoundedClient = true
                            this.$store.dispatch('clients/getClient', { user_id: +this.$route.params['clientId'] }).then(response => {
                                if (response.ok) {
                                    this.clientId = +this.$route.params['clientId']
                                    this.clientFormShow = true
                                }
                            })
                        }
                    } else {
                        this.clientId = +this.$route.params['clientId']
                        this.clientFormShow = true
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        searchClients() {
            this.page = 1
            this.$store.dispatch('clients/getClientsCount',
                { botId: this.$route.params['pathMatch'], group_id: this.mailingGroupId, search_text: this.search, search_by: this.searchBy })
            this.getDataFromApi()
        },
        reloadClients() {
            this.$store.dispatch('clients/getClientsCount',
                { botId: this.$route.params['pathMatch'], group_id: this.$route.params['1'], search_text: '', search_by: 'last_name' })
            this.getDataFromApi()
        },
        addClientsNotification(params) {
            this.paramsSnackbar.text = params.text
            this.paramsSnackbar.color = params.color
            this.snackbar = true
        },
        getDataFromApi () {
            this.loading = true
            let groupId = 0
            let pageAction = 'all'
            let lastUserId = { user_id: 0, id: 0 }
            if (this.$route.params.hasOwnProperty('groupId')) {
                groupId = +this.$route.params.groupId
            }
            if (this.clients.length > 0) {
                switch (this.options.page) {
                case 1: // первая страница
                    pageAction = 'all'
                    lastUserId = { user_id: 0 }
                    break
                case Math.trunc(this.countClients / this.options.itemsPerPage) +
                    (this.countClients % this.options.itemsPerPage > 0 ? 1 : 0): // последняя страница
                    pageAction = 'last'
                    break
                default:
                    if (this.lastPage - this.options.page > 0) { // предыдущая страница
                        pageAction = 'previous'
                        lastUserId = Object.assign({}, this.getFirstClient)
                    } else { // следующая страница
                        pageAction = 'next'
                        lastUserId = Object.assign({}, this.getLastClient)
                    }
                }
            }
            let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : 'user_id'
            let options = Object.assign(
                {
                    botId: this.$route.params['pathMatch'],
                    group_id: groupId,
                    pageAction: pageAction,
                    lastUserId: lastUserId[sortBy],
                    search_text: this.search,
                    search_by: this.searchBy
                },
                this.options)
            if (options.pageAction === 'last') { options.itemsPerPage = this.countClients % this.options.itemsPerPage <= 0 ? 15 : this.countClients % this.options.itemsPerPage }
            delete options.mustSort
            delete options.multiSort
            delete options.groupBy
            delete options.groupDesc
            this.$store.dispatch('clients/loadClientsByOptions', options)
                .then(response => {
                    this.lastPage = this.options.page
                    this.loading = false
                }, error => {
                    console.log(error)
                })
        },
        editClient(clientUserId) {
            this.clientId = clientUserId
            this.clientFormShow = true
        },
        getDate(updatedAt) { return timeHelpers.getTimeOutUnixTime(updatedAt) + ' ' + timeHelpers.getDateOutUnixTime(updatedAt) },
        handleResize() {
            this.windowHeight = window.innerHeight
        }
    },
    created () {
        let groupId = this.$route.params.hasOwnProperty('groupId') ? this.$route.params.groupId : 0
        this.$store.dispatch('clients/getClientsCount',
            { botId: this.$route.params['pathMatch'], group_id: groupId, search_text: '', search_by: 'last_name' })
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.mobile = true
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
    .container-to-table {
        display: flex;
        flex-direction: column;
    }
    .v-text-field {
        font-size: 0.9em;
    }
</style>
